var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoolActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_5728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.531898C11.7376 -0.182633 13.2624 -0.182633 14.5 0.531898L21.4317 4.5339C22.6693 5.24843 23.4317 6.56894 23.4317 7.998V16.002C23.4317 17.4311 22.6693 18.7516 21.4317 19.4661L14.5 23.4681C13.2624 24.1826 11.7376 24.1826 10.5 23.4681L3.56833 19.4661C2.33073 18.7516 1.56833 17.4311 1.56833 16.002V7.998C1.56833 6.56894 2.33073 5.24843 3.56833 4.5339L10.5 0.531898Z",
    fill: "#3E7AF5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.6894,
    height: 2.88928,
    rx: 0.846983,
    transform: "matrix(0.328046 -0.944662 0.944661 0.328047 8.18687 16.875)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5339 10.9118C18.1637 9.36939 17.1966 7.00554 13.5964 6.04677C9.99627 5.088 7.7446 5.75672 6.31133 6.79803C6.02859 7.07028 6.19359 7.55938 6.58217 7.61478C7.78491 7.78626 9.93876 8.1564 12.2275 8.85259C14.5774 9.56739 16.6923 10.7108 17.8145 11.3755C18.149 11.5736 18.5832 11.2975 18.5339 10.9118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0411 13.9258C14.6733 14.3115 13.8764 15.7344 14.2621 17.1022C14.6478 18.47 16.0707 19.267 17.4385 18.8813C18.8063 18.4956 19.6032 17.0727 19.2175 15.7049C18.8318 14.3371 17.409 13.5401 16.0411 13.9258Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_5728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolActive);
export default __webpack_public_path__ + "static/media/pool_active.938d2871b6d4b6cee8d986b5a92e21c6.svg";
export { ForwardRef as ReactComponent };